import React, { useContext } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceListLayer from "../components/InvoiceListLayer";
import { ConfigContext } from "../context/GlobalContext";
import { Languages } from "../Utils/Languages";
import ProformaInvoiceListLayer from "../components/ProformaInvoiceListLayer";
import QuotationListLayer from "../components/QuotationListLayer";


const QuotationListPage = () => {

  const { state } = useContext(ConfigContext);


  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Quotation - List" />

        {/* InvoiceListLayer */}
        <QuotationListLayer businessData={state?.BUSINESSES} invoiceData={state?.QUOTATION} />

      </MasterLayout>

    </>
  );
};

export default QuotationListPage;
